import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../auth/login.service';
import { PermissionType } from '../Models/JWTTokenResponse.model';

@Injectable({
  providedIn: 'root'
})
export class HasRoleGuard implements CanActivate {
  constructor(
    private loginService: LoginService,
    private router: Router

  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const userRoles = this.loginService.getUserCodes();
    const routeCode = route.data["code"];
    if (!routeCode) return true;
    const userHasCode = userRoles.some((role) => role.securityCode === routeCode && role.permission !== PermissionType.Deny);

    if (!userHasCode) {
      console.log("route.data['permission'] ", userHasCode);
      return this.router.navigate(['/main/permission-error']);
    }

    return true;
  }
}
